import { ServerError } from '~/infra/error-response/ErrorResponse';
export function updateRelationshipErrorMessage(error, errorTexts) {
    if (error.hasServerError(ServerError.MismatchingRelationshipVersion)) {
        return errorTexts.relationship.mismatchingVersion();
    }
    if (error.hasServerError(ServerError.CannotUpdateWithUnsentChanges)) {
        return errorTexts.relationship.cannotUpdateWithUnsentChanges();
    }
    if (error.hasServerError(ServerError.UnresolvedTemplateVariables)) {
        return errorTexts.relationship.unrecognizedCustomFields();
    }
    if (error.hasServerError(ServerError.ServiceEffectiveDateMustBeInFuture)) {
        return errorTexts.relationship.serviceEffectiveDateMustBeInFuture();
    }
    return errorTexts.unexpected();
}
